import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useLocation } from 'react-router';
import ImageAssets from 'src/assets/images';
import Iconify from 'src/components/iconify';
import { useAuthContext } from 'src/contexts/auth-provider';
import { useRouter } from 'src/hooks';
import Paths from 'src/paths';
import Formats from 'src/utils/format';

interface LinkIconProps {
  icon: string;
  href?: string;
  className?: string;
  onClick?: VoidFunction;
}

function LinkIcon(props: LinkIconProps) {
  return (
    <a
      href={props.href}
      onClick={props.onClick}
      className={`flex px-1 h-10 md:h-11 cursor-pointer items-center justify-center ${props.className}`}>
      <Iconify icon={props.icon} color="white" className="h-6 w-6 md:h-7 md:w-7" />
    </a>
  );
}

interface MainHeaderProps {
  onChangeMenuVisible?: VoidFunction;
}

export default function MainHeader(props: MainHeaderProps) {
  const router = useRouter();
  const currentPaths = useLocation();
  const { auth, balance, is_loading: isLoadingBalance } = useAuthContext();
  const [cookies, setCookies] = useCookies();
  const isDesktop = cookies.isDesktop;

  const onSwitchDevice = () => {
    setCookies('isDesktop', !isDesktop);
    router.reload();
  };
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  useEffect(() => {
    if (isDesktop === undefined) {
      setCookies('isDesktop', !isMobile);
    }
  }, [isDesktop, isMobile]);

  const isOutSourceGame =
    currentPaths.pathname === Paths.routes.game.sport ||
    currentPaths.pathname === Paths.routes.game.casino.root ||
    currentPaths.pathname === Paths.routes.game.slot.root ||
    currentPaths.pathname.includes(Paths.routes.game.slot.play);

  const isOutSourceGameReport =
    currentPaths.pathname === Paths.routes.report.sport ||
    currentPaths.pathname === Paths.routes.report.casino ||
    currentPaths.pathname === Paths.routes.report.fishing;

  const isFishGame =
    currentPaths.pathname === Paths.routes.game.fishing.root ||
    currentPaths.pathname.includes(Paths.routes.game.fishing.play);

  const isSpecificUser = [
    263, 82, 184, 431, 184, 431, 525, 766, 807, 814, 816, 837, 7330, 9423, 13101, 17917, 17918, 17919,
  ].includes(Number(auth?.id));

  return (
    <div className="bg-primary flex-row min-h-10 md:min-h-11 px-1 items-center">
      <LinkIcon icon={'line-md:menu'} className={`lg:w-10 lg:mr-0.5`} onClick={props.onChangeMenuVisible} />

      {isMobile && (isOutSourceGame || isFishGame) ? (
        <LinkIcon icon={'famicons:arrow-back-outline'} className={`lg:w-10 lg:mr-0.5`} onClick={() => history.back()} />
      ) : (
        ''
      )}

      {!isMobile && (isOutSourceGame || isFishGame) && (
        <LinkIcon onClick={() => router.push('/')} icon="line-md:home-twotone" className="md:hidden" />
      )}
      <a href="/" className="hidden md:block">
        <LazyLoadImage src={ImageAssets.Logo} className="ml-1 h-10" />
      </a>
      <label className="text-white text-xs md:text-sm lg:text-base px-2 font-bold">
        {auth?.username.toUpperCase()}
      </label>
      {isOutSourceGame || isFishGame || isOutSourceGameReport ? (
        <div className="flex-1 items-center justify-center"></div>
      ) : (
        <div className="flex-1 items-center justify-center">
          <LazyLoadImage src={ImageAssets.Name} className="h-8 lg:h-9 hidden md:block" />
        </div>
      )}
      {isOutSourceGame ? (
        ''
      ) : (
        <label className="flex flex-row items-center text-white text-xs md:text-sm lg:text-base px-2 font-bold">
          ទឹកប្រាក់:{' '}
          {isLoadingBalance ? (
            <Iconify icon={'eos-icons:three-dots-loading'} fontSize={40} />
          ) : (
            <span>{Formats.currency(balance || 0)} ៛</span>
          )}
        </label>
      )}
      <LinkIcon onClick={() => router.reload()} icon="line-md:backup-restore" className="md:hidden" />
      {/* <a href="/lotto" className="mx-1 hidden md:block">
        <button className="w-24 h-9 border-[1px] md:border-1 border-white border-solid rounded md:rounded-lg bg-primary text-white text-sm hover:bg-white hover:text-primary">
          ប្ដូរទម្រង់ចាស់
        </button>
      </a> */}
      <LinkIcon
        onClick={() => onSwitchDevice()}
        icon={isDesktop ? 'fa:mobile' : 'famicons:desktop-outline'}
        className="md:hidden"
      />
      {isSpecificUser && (isOutSourceGame || isFishGame) && (
        <a onClick={() => onSwitchDevice()} className="mx-1 hidden md:block">
          <button className="flex items-center justify-center w-28 h-9 border-[1px] md:border-1 border-white border-solid rounded md:rounded-lg bg-sky-600 text-white text-sm hover:bg-sky-900">
            <Iconify icon={isDesktop ? 'fa:mobile' : 'famicons:desktop-outline'} className="text-white mr-2 text-xl" />
            {isDesktop ? 'Mobile' : 'Desktop'}
          </button>
        </a>
      )}

      <a onClick={() => router.reload()} className="mx-1 hidden md:block">
        <button className="w-24 h-9 border-[1px] md:border-1 border-white border-solid rounded md:rounded-lg bg-primary text-white text-sm hover:bg-white hover:text-primary">
          បើកម្ដងទៀត
        </button>
      </a>
    </div>
  );
}
